import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
    ProviderTab,
    StyledCard,
    StyledCardContent,
    InputWithEndAdornment,
    SearchIcon,
    ContainedButton,
    Progress,
} from '../../components/index';

import { providerPageWidth } from '../../constant';

import PatientList from '../../components/Provider/Patient/PatientList';
import PrimaryPatient from '../../components/Provider/Profile/PrimaryPatient';

import { GET_PATIENTS } from '../../services/provider';
import { alertError } from '../../redux/stateActions';

const Patient = ({ history, location }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const [selectedTab, setSelectedTab] = useState(location?.state?.tab || 0);

    const tabsChangeHandler = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const [searchValue, setSearchValue] = useState('');

    /*--------------- Patient List ---------------*/
    const [patientListData, setPatientListData] = useState([]);
    const { loading, error, data, refetch } = useQuery(GET_PATIENTS, {
        variables: { id: user.staff.hospital.id },
        skip: _.isEmpty(user),
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (error) {
            dispatch(alertError(`Cannot get Client List: ${error.message}`));
        }

        if (data && data.hospital && data.hospital.patients) {
            const filtered = data.hospital.patients.filter((p) => p.user !== null);

            if (searchValue === '') {
                setPatientListData(filtered);
            } else {
                const newPatientListData = [...filtered].filter(
                    (patient) =>
                        patient?.HNCode?.toLowerCase().includes(searchValue.toLowerCase()) ||
                        patient?.user?.fullname?.toLowerCase().includes(searchValue.toLowerCase())
                );
                setPatientListData(newPatientListData);
            }
        }
    }, [data, error, searchValue]);

    return (
        <div
            style={{
                padding: '41px 20px 50px',
                maxWidth: providerPageWidth,
                width: '100%',
            }}
        >
            <Tabs
                value={selectedTab}
                onChange={tabsChangeHandler}
                TabIndicatorProps={{ style: { background: 'transparent' } }}
                variant="standard"
            >
                <ProviderTab label="Client List" $active={selectedTab === 0} />
                {['Provider', 'Provider Admin'].includes(user.staff.staff_role.name) && (
                    <ProviderTab label="Primary Client" $active={selectedTab === 1} />
                )}
            </Tabs>

            {selectedTab === 0 && (
                <StyledCard style={{ marginTop: '20px', padding: '30px 50px 24px 35px' }}>
                    {loading && <Progress />}
                    <StyledCardContent
                        style={{ display: 'flex', flexDirection: 'column', rowGap: '40px' }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <InputWithEndAdornment
                                id="search"
                                name="search"
                                placeholder="Search name or Code"
                                startAdornment={
                                    <InputAdornment
                                        position="start"
                                        style={{ opacity: 0.6, marginLeft: '10px' }}
                                    >
                                        <SearchIcon fill="gray2" />
                                    </InputAdornment>
                                }
                                type="text"
                                style={{ maxWidth: '325px', height: '32px' }}
                                inputPropsStyle={{ paddingLeft: '15px' }}
                                onChange={(e) => setSearchValue(e.target.value)}
                                value={searchValue}
                                inputProps={{ maxLength: 30 }}
                            />
                            {['Admin', 'Provider Admin'].includes(user.staff.staff_role.name) && (
                                <ContainedButton
                                    $backgroundColor="purple"
                                    $width="220px"
                                    $height="32px"
                                    onClick={() => {
                                        history.push({
                                            pathname: '/provider/client/add',
                                            state: {
                                                prevPath: '/provider/client',
                                            },
                                        });
                                    }}
                                >
                                    Add new client
                                </ContainedButton>
                            )}
                        </div>
                        <PatientList data={patientListData} prevTab={0} />
                    </StyledCardContent>
                </StyledCard>
            )}
            {['Provider', 'Provider Admin'].includes(user.staff.staff_role.name) &&
                selectedTab === 1 && <PrimaryPatient prevTab={1} />}
        </div>
    );
};

Patient.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
};

export default Patient;
